import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rgba } from 'polished';
import theme from '../../theme';

const Container = styled.div`
  background-color:  ${theme('colors.backgroundVeryDark').apply(col => rgba(col, 0.4))};
  border-radius: ${theme('radius.regular')};
  position: relative;
  width: 100%;
`;

const ListWrapper = ({ children = [] }) => (
  <Container>
    { children }
  </Container>
);

ListWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

ListWrapper.defaultProps = {};

export default ListWrapper;
